module.exports = __webpack_public_path__ + "static/img/hala19.18417e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hala/hala19.jpg
// module id = 4VWw
// module chunks = 1